<template>
  <div class="fts-calendar-view">
    <fts-full-calendar :events="events">
      <div slot="headerContent" class="date-selection">
        <div class="date-label">start from</div>
        <fts-select
          :options="columns"
          label="displayName"
          :reduce="(x) => x"
          placeholder="start date"
          :formData="formData"
          :item="{ fieldName: 'startDate' }"
          class="date-select"
        />
        <div class="date-label">until</div>
        <fts-select
          :options="columns"
          label="displayName"
          :reduce="(x) => x"
          placeholder="end date"
          :formData="formData"
          :item="{ fieldName: 'endDate' }"
          class="date-select"
        />
      </div>
      <!-- events -->
      <template #eventContent="{ event, contentClass, titleClass }">
        <a
          :class="contentClass"
          :href="locusUrl(event.id)"
          class="cv-event-trigger"
          @click.prevent="executeActivity(event.id)"
          v-if="viewRight"
        >
          <div :class="titleClass">{{ event.title }}</div>
        </a>
        <div :class="contentClass" class="cv-event-label" v-else>
          <div :class="titleClass">{{ event.title }}</div>
        </div>
      </template>
    </fts-full-calendar>
  </div>
</template>

<script>
import commons from "../../commons/commons";
import FTSFullCalendar from "../FTSFullCalendar";
import FTSSelect from "../FTSSelect";

export default {
  components: {
    "fts-full-calendar": FTSFullCalendar,
    "fts-select": FTSSelect,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    standardActions: {
      type: Array,
      default: () => [],
    },
    moduleId: Number,
    listingId: String
  },
  data: () => ({
    formData: {},
  }),
  methods: {
    locusUrl(id) {
      return commons.clientPathUrl({
        moduleId: this.moduleId,
        listId: this.listingId,
        id: id,
      });
    },
    executeActivity(itemId) {
      let res = this.list.find((x) => x.id == itemId);
      if (res)
        this.$emit("executeActivity", {
          activity: { id: 'quickView'},
          items: [res],
        });
    },
  },
  computed: {
    // rights
    viewRight() {
      return (
        this.standardActions.indexOf("view") > -1 ||
        this.standardActions.indexOf("quickView") > -1
      );
    },
    events() {
      return this.list.map((x) => {
        let event = {
          id: x.id,
          title: `${x.documentId} ${x.title}`,
          start: x.audit.updatedDate,
        };
        if (this.formData.startDate)
          event.start = this.formData.startDate.system
            ? x.audit[this.formData.startDate.fieldName]
            : x.extension[this.formData.startDate.fieldName];
        if (this.formData.endDate)
          event.end = this.formData.endDate.system
            ? x.audit[this.formData.endDate.fieldName]
            : x.extension[this.formData.endDate.fieldName];
        return event;
      });
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-calendar-view {
  padding-left: 1rem;
  padding-right: 1rem;
  .date-selection {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    .date-label {
      margin-right: 0.575rem;
      font-size: 0.75rem;
      white-space: nowrap;
      color: var(--fts-text);
      &:not(:first-child) {
        margin-left: 0.575rem;
      }
    }
    .date-select {
      width: 200px;
    }
  }
  .cv-event-trigger {
    text-decoration: none;
    color: #fff;
  }
  .cv-event-label {
    text-decoration: none;
    cursor: default;
  }
}
</style>